module.exports = __webpack_public_path__ + "media/images/covid/icons/thermograph-7845d3bc26c3d128b7d0022f82c5b0ee.png";